var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_c('article',{staticClass:"forms"},[_c('top-navbar'),_c('auth-content')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/img/logo_dsvrt_white.jpeg"),"alt":"DSVRT Lagos"}})])
}]

export { render, staticRenderFns }